import { ComponentHelper } from "../../core/util/componentHelper";
import { Dialog, DialogAction } from "../../core/components/dialog";
import { TextBox } from "../../core/components/textBox";
import { FieldInstance } from "../../core/components/field";
import { Config } from "../../core/config/config";
import { DatePicker } from "../../core/components/datePicker";
import { Helper } from "../../core/util/helper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ExecutionDialog extends React.Component<CancelDialogProps, CancelDialogState>
{
    private factory = ComponentHelper.createFactory();
    private actions: Array<DialogAction> = [
        {
            label: Config.translations.cancel,
            action: () => {
            }
        },
        {
            label: Config.translations.ok,
            action: () => {
                if (!this.props.showDatePicker || Helper.hasValue(this.props.dateValue))
                    this.props.onDialogOk()
                else
                    DialogHelper.alert(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.MandatoryField"));
            },
            primary: true
        }
    ]



    constructor(props: CancelDialogProps) {
        super(props)
        this.state = {
            dialogOpen: false,
        }
    }

    openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    private getTextBoxProps = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.props.textBoxValue;
        props.field.model = "DialogComment";
        props.field.multiLine = true;
        props.onChange = (_, value: string) => {
            this.props.onTextBoxChange(value)
        };
        return props;
    }

    private getDatePickerProps = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.field.clearTime = true;
        props.value = this.props.dateValue;
        props.field.model = "DialogDate";
        props.onChange = (_, value: string) => { this.props.onDateChange(value) };
        return props;
    }

    private getDatePicker() {
        if (!this.props.showDatePicker)
            return null;
        const datePickerProps = this.getDatePickerProps();
        return <FieldInstance noHover={true} label={this.props.datePickerText}>
            <DatePicker {...datePickerProps} />
        </FieldInstance>;
    }

    private getCommentLabel() {
        if (!Helper.hasValue(this.props.comment))
            return null;
        const labelStyle: React.CSSProperties = {
            color: "#ff0000"
        }
        return <label style={labelStyle}>{this.props.comment}</label>;
    }

    private afterClose = () => {
        this.setState({ dialogOpen: false })
    }

    private createDialog = () => {
        const textBoxCommentProps = this.getTextBoxProps();
        var datePicker = this.getDatePicker();
        var comment = this.getCommentLabel();

        return (
            <Dialog title={this.props.title}
                actions={this.actions} open={true} afterClose={() => { this.afterClose() }}>
                <div style={{ width: "800px" }}>
                    <label>{this.props.label}</label>
                    <FieldInstance noHover={true} label={Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Comment")}>
                        <TextBox {...textBoxCommentProps} />
                    </FieldInstance>
                    {datePicker} 
                    {comment}
                </div>
            </Dialog>);
    }

    render() {
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return dialog;
    }
}

interface CancelDialogProps {
    title: string,
    textBoxValue: string,
    dateValue?: string,
    showDatePicker?: boolean;
    label: string;
    onTextBoxChange: (value: string) => void;
    onDateChange?: (value: string) => void; 
    onDialogOk: () => void
    translations: StringKeyDictionary<string>;
    comment?: string;
    datePickerText?: string;
}

interface CancelDialogState {
    dialogOpen: boolean,
}